// eslint-disable-next-line eslint-comments/disable-enable-pair -- This is a bug and should be fixed!
/* eslint-disable prettier/prettier -- Bug or mismatch between eslint and prettier */
import ProductMeta from '@sportson/core-web/components/metadata/ProductMeta';
import { inServer } from '@sportson/core-web/constants';
import GetProductPriceQtyBreak from '@sportson/core-web/libs/GrebbCommerceAPI/Products/GetProductPriceQtyBreak';
import GetProductRelations from '@sportson/core-web/libs/GrebbCommerceAPI/Products/GetProductRelations';
import { buildQueryString } from '@sportson/core-web/libs/GrebbCommerceAPI/util';
import { getState, injectModels } from '@sportson/core-web/state';
import hideOverlays from '@sportson/core-web/state/models/Overlay/dispatches/hideOverlays';
import comparePriceToParent from '@sportson/core-web/utils/comparePriceToParent';
import { onHandCheck } from '@sportson/core-web/utils/getProductStockStatus';
import getQueryParams from '@sportson/core-web/utils/getQueryParams';
import { isEmpty } from '@sportson/core-web/utils/object';
import { PRODUCT_BACKORDER, PRODUCT_PREORDER, STORM_PACKAGE_TYPES, PARAMETRIC_COLOR_ID } from 'config/constants';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { withRouter } from 'react-router-dom';


const PRODUCTPAGERELATIONS = 'ADD CORE HERE'; // @TODO <---- fix this
const initialState = {
    isPackage: false,
    product: null,
    qtyBreaks: [],
    quantity: 1,
    productRelations: [],
    variantRelations: {},
    selectedProduct: null,
    selectedProductVariants: {},
    bestHistoricalPrice: {},
};

export const getFlag = (code, product = {}) => {
    const findFlag = (flag) => {
        if (Array.isArray(code)) {
            return code.some((c) => c.toLowerCase() === flag.code?.toLowerCase());
        }

        return flag.code?.toLowerCase() === code?.toLowerCase();
    };
    return (product?.format?.flags || []).find(findFlag) || false;
};

export const getParametric = (code, product = {}) => {
    const parametrics = product.parametrics || [];
    const variantParametrics = product.variantParametrics || [];

    const findParametric = (parametric) => {
        if (Array.isArray(code)) {
            return code.indexOf(parametric.code) !== -1 && parametric?.value?.length > 0;
        }
        return parametric.value?.length > 0 && parametric.code === code;
    };

    return parametrics.find(findParametric) || variantParametrics.find(findParametric);
};

const isVariantProduct = (product) => (product.variants || []).length > 0;
const isPackageProduct = (product) => STORM_PACKAGE_TYPES.indexOf(product.type) !== -1;

class ProductPageContainer extends Component {
    static propTypes = {
        loading: PropTypes.func,
        location: PropTypes.object.isRequired,
        page: PropTypes.object.isRequired,
        render: PropTypes.func.isRequired,
        shouldFetchRelations: PropTypes.bool,
    };

    static defaultProps = {
        loading: null,
        shouldFetchRelations: true,
    };

    state = this.resetState(this.props.page?.data?.product);

    componentDidMount() {
        this.getProductRelations();
        this.getQtyBreaks();
    }

    shouldComponentUpdate(nextProps, nextState) {

        if (JSON.stringify(nextState) !== JSON.stringify(this.state)) {
            return true;
        }

        const product = this.state.product || {};
        const nextProduct = nextProps?.page?.data?.product || {};
        const productVariants = nextProduct?.variants || [];

        if (
            (nextProduct.partNo !== product.partNo &&
                (!productVariants.length || productVariants[0].partNo !== product.partNo)) ||
            (nextProduct.price !== product.price &&
                (!productVariants.length || productVariants[0].price !== product.price)) ||
            (nextProduct.priceListId !== product.priceListId &&
                (!productVariants.length || productVariants[0].priceListId !== product.priceListId))
        ) {
            this.setState(this.resetState(nextProduct), () => {
                this.getProductRelations();
                this.getQtyBreaks();
            });
        }

        return false;
    }

    componentWillUnmount() {
        const { current } = getState('overlay');
        if (current === 'gallery_zoom_overlay') {
            hideOverlays();
        }
    }

    resetState(product) {
        const newState = { ...initialState };
        const { search } = this.props.location;
        const query = getQueryParams({ search });
        if (!product) {
            return newState;
        }

        const hasPartNo = product.variants.some((p) => p.partNo === query.p);

        const presetPartNoLocationState = this.props.location.state?.presetPartNo;
        const hasPresetPartNo = product.variants.some((p) => p.partNo === presetPartNoLocationState);

        // Remove queryParam from URL if query.id doesnt exists in product.variants
        if (!hasPartNo && !inServer) {
            const { location } = window;
            let queryParams = '';
            if (!isEmpty(query)) {
                if (query.hasOwnProperty('p')) {
                    delete query.p;
                }
                queryParams = `?${buildQueryString(query)}`;
            }

            if (hasPresetPartNo && !query.p) {
                query.p = presetPartNoLocationState;

                queryParams = `?${buildQueryString(query)}`;
            }

            const currentPathAndSearch = `${location.pathname}${location.search}`;
            const newPathAndSearch = `${location.pathname}${queryParams}`;
            if (currentPathAndSearch !== newPathAndSearch) {
                window.history.replaceState(null, null, `${location.pathname}${queryParams}`);
            }
        }

        const isVariant = isVariantProduct(product);
        const isPackage = isPackageProduct(product);

        const { variants } = product;

        const selectedProductVariants = {};
        if (isPackage && !isVariant && (product.includedProducts || []).length) {
            product.includedProducts.forEach((subProduct) => {
                if ((subProduct.variants || []).length > 1) {
                    selectedProductVariants[subProduct.id] = null;
                } else {
                    selectedProductVariants[subProduct.id] = subProduct;
                }
            });
        } else if (isVariant && !hasPartNo && !hasPresetPartNo) {
            const [firstActiveVariant] = variants.filter((p) => p.statusId === 1);
            const [firstVariant] = variants;
            selectedProductVariants[product.id] = firstActiveVariant || firstVariant;
        } else if (isVariant && (hasPartNo || hasPresetPartNo)) {
            const selectedVariant = variants.find((p) => p.partNo === query.p);
            selectedProductVariants[product.id] = selectedVariant;
        } else {
            selectedProductVariants[product.id] = product;
        }

        const selectedVariant = selectedProductVariants[product.id] || {};

        const { bestHistoricalPriceIncVat } = product;
        const bestHistoricalPrice = bestHistoricalPriceIncVat / product.vatRate;

        const selectedProduct = this.getSelectedProductData(selectedVariant, product, variants);

        return {
            ...newState,
            bestHistoricalPrice,
            isPackage,
            product,
            quantity: product.recommendedQuantity ? product.recommendedQuantity : 1,
            selectedProduct,
            selectedProductVariants,
            variants,
        };
    }

    getSelectedProductData(selectedVariant, product, variants) {
        if (!inServer) {
            const { search, pathname } = this.props.location;
            const query = getQueryParams({ search });
            const currentPathAndSearch = `${pathname}${search}`;

            if (Object.prototype.hasOwnProperty.call(query, 'p')) {
                delete query.p;
            }
            const queryParams = buildQueryString(query);
            let newPathAndSearch = queryParams ? `${pathname}?${queryParams}` : pathname;

            if (variants.length && selectedVariant.partNo) {
                newPathAndSearch = `${pathname}?p=${selectedVariant.partNo}${queryParams ? `&${queryParams}` : ''}`;
            }

            if (currentPathAndSearch !== newPathAndSearch) {
                window.history.replaceState(null, null, newPathAndSearch);
            }
        }

        const selectedProduct = Object.keys(selectedVariant || {}).length ? selectedVariant : product;
        const isPackage = isPackageProduct(selectedProduct);

        // const packageImages = isPackage
        //     ? (product.includedProducts || []).reduce((images, incProduct) => {
        //           if (incProduct.format?.image) {
        //               return [
        //                   ...images,
        //                   {
        //                       name: incProduct.name,
        //                       format: incProduct.format,
        //                       type: 1,
        //                   },
        //               ];
        //           }
        //           return images;
        //       }, [])
        //     : [];

        const isBookable =
            !!getFlag(PRODUCT_PREORDER, selectedProduct) || !!getFlag(PRODUCT_BACKORDER, selectedProduct);

        const selectedProductParametrics = !isPackage
            ? selectedProduct.parametrics
            : (selectedProduct.includedProducts || [])
                .map((p) => ({ name: p.name, parametrics: p.parametrics }))
                .filter((p) => p.parametrics.length);
        const parametrics = JSON.parse(JSON.stringify(selectedProductParametrics || []));

        product.parametrics.forEach(
            (parametric) =>
                parametrics.every((addedParametric) => addedParametric.code !== parametric.code) &&
                parametrics.push(parametric),
        );
        const variantParametrics = !isPackage
            ? selectedProduct.variantParametrics
            : (selectedProduct.includedProducts || [])
                .map((p) => ({ name: p.name, variantParametrics: p.variantParametrics }))
                .filter((p) => p.variantParametrics.length);

        const format = selectedVariant.format || product.format || {};
        return {
            catalogPriceExVat: selectedProduct.priceCatalog || product.priceCatalog,
            categories: selectedVariant.categories || product.categories || [],
            description: selectedVariant.description || product.description,
            descriptionHeader: selectedVariant.descriptionHeader || product.descriptionHeader,
            eanCode: selectedVariant.eanCode || product.eanCode,
            files: selectedProduct.files,
            flags: selectedVariant?.format?.flags || product?.format?.flags || [],
            format,
            id: selectedVariant.id,
            image: format?.image,
            imageKey: selectedProduct.imageKey,
            includedProducts: selectedProduct.includedProducts,
            isBookable,
            isPackage,
            manufacturer: selectedVariant.manufacturer || product.manufacturer,
            manufacturerPartNo: selectedProduct.manufacturer?.partNo || product.manufacturer?.partNo,
            name: selectedVariant.variantName || product.name,
            onHand: selectedVariant.onHand || product.onHand,
            onHandStore: selectedVariant.onHandStore || product.onHandStore,
            parametrics,
            partNo: selectedProduct.partNo,
            priceExVat: selectedProduct.price || product.price,
            priceListCode: selectedProduct.priceListCode,
            priceListId: selectedProduct.priceListId,
            quantity: selectedProduct.quantity,
            recommendedPriceExVat: selectedProduct.priceRecommended || product.priceRecommended,
            standardPriceExVat: selectedProduct.priceStandard || product.priceStandard,
            type: selectedProduct.type,
            uom: selectedProduct.uom,
            variantParametrics,
            vatRate: selectedProduct.vatRate || product.vatRate,
        };
    }

    getProductRelations = async () => {
        const productId = this.state.product && this.state.product.id;

        if (productId && this.props.shouldFetchRelations) {
            try {
                const response = await GetProductRelations(productId, { asVariants: true });
                const productPageRelations = response?.data.find(({ code }) => code === PRODUCTPAGERELATIONS);
                const productRelations = productPageRelations?.relations?.items || [];
                const variantRelations = productPageRelations?.variantRelations || [];

                const mappedVariantRelations = variantRelations.reduce((allRelations, relation) => {
                    const relations = relation?.relations?.items || [];

                    const mappedVariants = relations.reduce((products, product) => {
                        let firstParentMatch = products.length
                            ? products.find((p) => p.oldVariants.some((v) => v.id === product.id))
                            : null;
                        const variant = product.variants.find((v) => v.id === product.id);

                        if (firstParentMatch) {
                            products = products.map((p) => {
                                if (p.id === firstParentMatch.id) {
                                    p.variants.push(variant);
                                }

                                return p;
                            });
                        } else {
                            firstParentMatch = product;
                            firstParentMatch.oldVariants = firstParentMatch.variants;
                            firstParentMatch.variants = [variant];

                            products.push(firstParentMatch);
                        }

                        return products;
                    }, []);

                    if (relation.id) {
                        allRelations[relation.id] = mappedVariants;
                    }

                    return allRelations;
                }, {});

                if (productRelations?.length || !isEmpty(mappedVariantRelations)) {
                    this.setState({
                        productRelations,
                        variantRelations: mappedVariantRelations,
                    });
                }
            } catch (e) {
                console.error(e);
            }
        }
    };

    returnLowestPrice = (currentPrice, newPrice) =>
        !currentPrice || currentPrice > newPrice ? newPrice : currentPrice;

    getPricingOfProducts = (products) => {
        const { product: mainProduct, selectedProductVariants, quantity = 1 } = this.state;

        let lowestMainProductPrice;
        if (mainProduct.variants?.length > 1) {
            lowestMainProductPrice = mainProduct.variants.reduce(
                (minPrice, variant) => {
                    const priceExVat = this.returnLowestPrice(minPrice.priceExVat, variant.price || 0);
                    const variantHasLowestPrice = minPrice.priceExVat === null || minPrice.priceExVat > priceExVat;
                    let { standardPriceExVat } = minPrice;
                    let { priceListId } = minPrice;
                    if (variantHasLowestPrice) {
                        standardPriceExVat = variant.priceStandard;
                        priceListId = variant.priceListId;
                    }
                    return {
                        priceListId,
                        priceExVat,
                        standardPriceExVat,
                    };
                },
                {
                    priceListId: mainProduct.priceListId,
                    priceExVat: null,
                    standardPriceExVat: null,
                },
            );
        }
        const price = products.reduce(
            (price, product) => {
                if (product) {
                    // We place a fallback to quantity "1" if it does not exist.
                    const productQuantity = product.quantity || 1;
                    const { includedProducts } = product;
                    let { priceListId } = product;
                    let productPrice = product.priceExVat || product.price || 0;
                    let productStandardPriceExVat =
                        comparePriceToParent(includedProducts) ||
                        product.standardPriceExVat ||
                        product.priceStandard ||
                        0;
                    const productVatRate = product.vatRate;

                    if (
                        (mainProduct.variants || []).some(({ partNo }) => partNo === product.partNo) &&
                        !selectedProductVariants[mainProduct.id]
                    ) {
                        priceListId = lowestMainProductPrice.priceListId;
                        productPrice = lowestMainProductPrice.priceExVat;
                        productStandardPriceExVat = lowestMainProductPrice.standardPriceExVat;
                    }

                    return {
                        ...price,
                        priceListId,
                        priceExVat: price.priceExVat + productPrice * productQuantity,
                        priceIncVat: price.priceIncVat + productPrice * productVatRate * productQuantity,
                        standardPriceExVat: price.standardPriceExVat + productStandardPriceExVat * productQuantity,
                    };
                }

                return price;
            },
            {
                priceListId: null,
                priceIncVat: 0,
                priceExVat: 0,
                standardPriceExVat: 0,
                quantityOfPackage: quantity > 0 ? quantity : 1,
            },
        );

        price.vatRate = price.priceIncVat / price.priceExVat || mainProduct?.vatRate || 1;

        return price;
    };

    getStockStatus = () => {
        const { isPackage, product, selectedProductVariants } = this.state;

        const mainProduct = selectedProductVariants[product.id] || product;
        const mainProductStock = onHandCheck(mainProduct.onHand?.value) || onHandCheck(mainProduct.onHandStore?.value);

        if (isPackage) {
            let allIncludedProductsHaveStock = true;

            product.includedProducts.forEach((incProduct) => {
                const selectedPackageVariant = selectedProductVariants[incProduct.id] || incProduct;
                const onHandSum =
                    onHandCheck(selectedPackageVariant.onHand?.value) +
                    onHandCheck(selectedPackageVariant.onHandStore?.value);
                const incProductStock = Math.floor(onHandSum / selectedPackageVariant.quantity);
                if (incProductStock < 1) {
                    allIncludedProductsHaveStock = false;
                }
            });

            return allIncludedProductsHaveStock;
        }
        return mainProductStock > 0;
    };

    getQtyBreaks = async () => {
        const { product } = this.state;

        if (product && product.id) {
            try {
                const response = await GetProductPriceQtyBreak(product.id);
                if (response.data && response.data.length > 1) {
                    const filteredResponse = response.data.filter(
                        (qtyProduct) => qtyProduct.part_no === product.partNo, // && qtyProduct.qty_break > 1
                    );

                    this.setState({
                        qtyBreaks: filteredResponse,
                    });
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    // -- -------- CALLBACKS

    setQuantity = (value) => {
        let quantity = value;

        if (typeof quantity === 'string') {
            quantity = +value;
        } else if (isNaN(quantity) || quantity === null || quantity === undefined) {
            quantity = 1;
        }

        this.setState({ quantity });
    };

    setVariant = (pId, pVariant) => {
        // Ge t the current selectedProductVariants from the state (as a new object)
        const selectedVariants = { ...this.state.selectedProductVariants };

        // If the productId is not the same as the new productVariant we update the state
        if (selectedVariants[pId] !== pVariant) {
            if (pVariant === undefined) {
                delete selectedVariants[pId];
            } else {
                selectedVariants[pId] = pVariant;
            }

            const newState = { selectedProductVariants: selectedVariants };

            // if new productVariant is set, update selectedProduct
            if (this.state.product && pId === this.state.product?.id) {
                newState.selectedProduct = this.getSelectedProductData(
                    pVariant || {},
                    this.state.product,
                    this.state.variants,
                );
            }

            this.setState(newState);
        }
    };

    render() {
        const {
            bestHistoricalPrice,
            isPackage,
            product,
            qtyBreaks,
            quantity,
            selectedProduct,
            selectedProductVariants,
            productRelations,
            variantRelations,
            variants,
        } = this.state;

        let relations = productRelations;
        if (selectedProduct && variantRelations[selectedProduct?.id]) {
            relations = relations.concat(variantRelations[selectedProduct.id]);
        }

        const { loading: Loading, page, render: Render } = this.props;
        const isQuantityPackage = isVariantProduct(product || {}) && selectedProduct.isPackage;

        if (!product && Loading) {
            return <Loading />;
        }

        let totalPricing = {};

        if (isPackage) {
            totalPricing = this.getPricingOfProducts([selectedProduct]);
        } else if (!selectedProductVariants[product.id]) {
            totalPricing = this.getPricingOfProducts([selectedProduct]);
        } else {
            totalPricing = this.getPricingOfProducts([...Object.values(selectedProductVariants)]);
        }

        const isInStock = !!this.getStockStatus();
        const colorParametric = selectedProduct.parametrics.find((x) => (x.id === PARAMETRIC_COLOR_ID))?.value;

        return (
            <>
                <ProductMeta product={product} colorParametric={colorParametric}/>
                <Render
                    bestHistoricalPrice={bestHistoricalPrice}
                    isBookable={!isInStock && selectedProduct.isBookable}
                    isExpired={!isInStock && selectedProduct.isExpired}
                    isInStock={isInStock}
                    isVariant={isVariantProduct(product)}
                    pageData={{
                        localeAlternates: page.localeAlternates,
                        defaultName: page.data?.defaultName,
                        defaultUniqueUrlName: page.data?.defaultUniqueUrlName,
                        id: page.data?.id,
                        partNo: page.data?.partNo,
                        variantPartNos: page.data?.variantPartNos,
                    }}
                    product={product}
                    qtyBreaks={qtyBreaks}
                    quantity={quantity}
                    isQuantityPackage={isQuantityPackage}
                    selectedProduct={selectedProduct}
                    selectedProductVariants={selectedProductVariants}
                    variants={variants?.length ? variants : product.variants}
                    totalPricing={totalPricing}
                    relations={relations}
                    onQuantityChange={this.setQuantity}
                    onUpsellChange={this.setUpsells}
                    onVariantChange={this.setVariant}
                />
            </>
        );
    }
}

export default withRouter(injectModels(['page', 'application'])(ProductPageContainer));
